import { useTranslation } from "react-i18next";

import { InitChatStatus } from "@/indexedDB/types";
import { useNavigationState } from "@/zustand/NavigationState";

import LoadingScreen from "@/components/shared/LoadingScreen";

export default function MessageListLoading({
  isLoading,
  children,
}: {
  isLoading?: boolean;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();

  const activeChatInitStatus = useNavigationState(
    (state) => state.activeChatInitStatus,
  );

  const isActiveChatInitialMessagesLoaded = useNavigationState(
    (state) => state.isActiveChatInitialMessagesLoaded,
  );

  if (
    isLoading ||
    !isActiveChatInitialMessagesLoaded ||
    activeChatInitStatus === InitChatStatus.PENDING
  ) {
    return (
      <div className="flex flex-1 items-center justify-center align-middle">
        <LoadingScreen
          title={
            activeChatInitStatus === InitChatStatus.PENDING
              ? t("creatingConversation")
              : t("loadingConversationHistory")
          }
        />
      </div>
    );
  }

  return <>{children}</>;
}
